import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Train, TrainViewmodel } from 'src/app/models/train.model';
import { TrainService } from 'src/app/services/trains/trains.service';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { Plant } from 'src/app/models/plant.model';
import { Unit } from 'src/app/models/unit.interface';
import { Stage } from 'src/app/models/stage.interface';
import { Hybrid } from 'src/app/models/hybrid.interface';
import { userAccessOption } from 'src/app/models/userAccessOption.interface';
import { User } from 'src/app/models/user.model';
import { UserService } from 'src/app/services/user/user.service';
import { Model } from 'src/app/models/model.model';
import { ModelsService } from 'src/app/services/models/models.service';
import { TrainUsers } from 'src/app/models/trainusers.model';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-add-train',
  templateUrl: './add-train.component.html',
  styleUrls: ['./add-train.component.scss'],
})
export class AddTrainComponent {
  dtoptions: DataTables.Settings = {};
  public units: Array<Unit> = [
    { Id: 0, UnitName: 'Metric' },
    { Id: 1, UnitName: 'English' },
  ];
  public stage: Array<Stage> = [
    { Id: 1, Name: '1' },
    { Id: 2, Name: '2' },
    { Id: 3, Name: '3' },
  ];
  public hybrid: Array<Hybrid> = [
    { Id: 0, Name: 'No' },
    { Id: 1, Name: 'Yes' },
  ];
  public hybridSt2: Array<Hybrid> = [
    { Id: 0, Name: 'No' },
    { Id: 1, Name: 'Yes' },
  ];
  public hybridSt3: Array<Hybrid> = [
    { Id: 0, Name: 'No' },
    { Id: 1, Name: 'Yes' },
  ];
  public useraccessOption: Array<userAccessOption> = [
    { Id: 1, Name: 'Allow Access For All Except Restricted Users:' },
    { Id: 0, Name: 'Restrict Access For All Except Permitted Users:' },
  ];
  [x: string]: any;
  plantValidator: boolean = false;
  nameValidator: boolean = false;
  plantSelected: boolean = false;
  stagevalidator: boolean = false;
  abc : string
  //stage 1

  //stage 1 Non  Hybrid
  stage1eleement1validator: boolean = false;
  Stage1elementVesselsValidator = false;
  stage1VesselValidator = false;
  //stage 1 Hybrid
  stage1element1hybridvalidator = false;
  stage1element2hybridvalidator = false;
  s1Q1Validator = false;
  s1Q2Validator = false;
  stage1VesselValidatorH = false;

  //stage 2
  //stage 2 Non Hybrid
  stage2Element1validator=false;
  Stage2elementVesselsValidator = false;
  stage2VesselValidator = false;
  //stage 2 Hybrid
  stage2Element1validatorH = false;
  stage2Element2validatorH = false;
  s2Q1Validator = false;
  s2Q2Validator = false;
  stage2VesselValidatorH = false;

  //stage 3
  //stage 2 Non Hybrid
  stage3Element1validatorNH = false;
  Stage3elementVesselsValidator = false;
  stage3VesselValidator = false;
  //stage 2 Hybrid
  stage3Element1ValidatorH = false;
  stage3Element2ValidatorH = false;
  s3Q1ValidatorH = false;
  s3Q2Validator = false;
  stage3VesselValidatorH = false;


  stageSelected: boolean = false;
  trains: Train[] = [];
  plants: Plant[] = [];
  users: User[] = [];
  models: Model[] = [];
  showDiv = false;
  showDiv2 = false;
  showHybrid = true;
  showStage1hybrid = false;
  stage2Nhybrid = true;
  showHybrid2 = true;
  showStage2hybrid = false;
  stage3Nhybrid = true;
  showHybrid3 = true;
  showStage3hybrid = false;
  trainUsers: TrainUsers[] = [];
  trainUserId: string = '';
  elementpervessele = false;
  elementperVesselstage2 = false;
  elementperVesselstage3 = false;
  constructor(
    private router: Router,
    private trainService: TrainService,
    private plantService: PlantsService,
    private userService: UserService,
    private modelService: ModelsService,
    private toastr: ToastrService
  ) {}

  onOptionSelected() {
    this.stagevalidator = false;
    let stageStr = this.addTrainRequest.Stages.toString();
    if (stageStr === '2') {
      this.showDiv = true;
      this.showDiv2 = false;
    } else if (stageStr === '3') {
      this.showDiv = true;
      this.showDiv2 = true;
    } else {
      this.showDiv = false;
      this.showDiv2 = false;
    }
  }
  onOptionHybrid() {
    let stage1Hybrid = this.addTrainRequest.Hybrid.toString();
    if (stage1Hybrid === '1') {
      this.showStage1hybrid = true;
      this.showHybrid = false;
      this.elementpervessele = true;
    } else {
      this.showStage1hybrid = false;
      this.showHybrid = true;
      this.elementpervessele = false;
      this.addTrainRequest.Stage1ElementsVessel = 0;
      this.addTrainRequest.Stage1Element1Qty = 0;
      this.addTrainRequest.Stage1Element2Qty = 0;
      this.addTrainRequest.Stage1Element3Qty = 0;
    }
  }

  onOptionHybridS2() {
    let stage2Hybrid = this.addTrainRequest.Hybrid2.toString();
    if (stage2Hybrid === '1') {
      this.showStage2hybrid = true;
      this.stage2Nhybrid = false;
      this.elementperVesselstage2 = true;
    } else {
      this.showStage2hybrid = false;
      this.stage2Nhybrid = true;
      this.elementperVesselstage2 = false;
      this.addTrainRequest.Stage2ElementsVessel = 0;
      this.addTrainRequest.Stage2Element1Qty = 0;
      this.addTrainRequest.Stage2Element2Qty = 0;
      this.addTrainRequest.Stage2Element3Qty = 0;
    }
  }

  onOptionHybridS3() {
    let stage3Hybrid = this.addTrainRequest.Hybrid3.toString();
    if (stage3Hybrid === '1') {
      this.showStage3hybrid = true;
      this.stage3Nhybrid = false;
      this.elementperVesselstage3 = true;
    } else {
      this.showStage3hybrid = false;
      this.stage3Nhybrid = true;
      this.elementperVesselstage3 = false;
      this.addTrainRequest.Stage3ElementsVessel = 0;
      this.addTrainRequest.Stage3Element1Qty = 0;
      this.addTrainRequest.Stage3Element2Qty = 0;
      this.addTrainRequest.Stage3Element3Qty = 0;
    }
  }

  loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
  CurrentUserId = this.loggedInuserRole.userId;
  formatsDateTest: string[] = ['yyyy/MM/dd HH:mm:ss'];
  selectedValues: User[] = [];
  selectedRestricted: User[] = [];
  selectedPlantId: number;
  comanyUsers: User[] = [];
  userLister: User[] = [];
  dateNow: Date = new Date();
  plantId: number;
  accessChoice: string;
  addTrainRequest: Train = new Train();
  addTrainUsers: TrainUsers = new TrainUsers();
  getSelectedPlantId(e) {
    this.plantValidator = false;
    //const selectedValue = e.target.value;
    //const plantId = selectedValue.split(':')[1].trim();
    const plantId = e.target.value.toString()
    this.plantId = plantId;
    console.log(this.plantId);
    this.trainService.GetUsersByPlantId(this.plantId).subscribe({
      next: (comanyUsers) => {
        this.comanyUsers = comanyUsers;
        console.log(this.comanyUsers);
      },
    });
  }
  onAccessOptionSelected(e) {
    console.log(e.target.value);
    this.accessChoice = e.target.value;
  }
  QuantityAdditionStage1() {
    this.addTrainRequest.Stage1ElementsVessel =
      Number(this.addTrainRequest.Stage1Element1Qty) +
      Number(this.addTrainRequest.Stage1Element2Qty) +
      Number(this.addTrainRequest.Stage1Element3Qty);
  }
  QuantityAdditionStage2() {
    this.addTrainRequest.Stage2ElementsVessel =
      Number(this.addTrainRequest.Stage2Element1Qty) +
      Number(this.addTrainRequest.Stage2Element2Qty) +
      Number(this.addTrainRequest.Stage2Element3Qty);
  }
  QuantityAdditionStage3() {
    this.addTrainRequest.Stage3ElementsVessel =
      Number(this.addTrainRequest.Stage3Element1Qty) +
      Number(this.addTrainRequest.Stage3Element2Qty) +
      Number(this.addTrainRequest.Stage3Element3Qty);
  }



  ngOnInit(): void {
    this.dtoptions = {
      pagingType: 'full_numbers',
    };
    this.addTrainRequest.Stages=1;
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if(loggedInuserRole.role =='Standard User')
    {
      this.plantService.getPlantsByUserId(loggedInuserRole.userId)
        .subscribe({
          next: (plants)=>{
            this.plants = plants;
            this.plantService.setPlants(plants);   // IMPORTANT: Store plants in service for later use
          },
        })

    }
    else
    {
      this.plantService.getAllPlant().subscribe({
        next: (plants) => {
          this.plants = plants;
          this.plantService.setPlants(plants);   // IMPORTANT: Store plants in service for later use
          console.log(this.plants);
        },
        error: (response) => {
          console.log(response);
        },
      });
    }
    this.userService.getAllUser().subscribe({
      next: (users) => {
        this.users = users;
        console.log(users);
      },
      error: (response) => {
        console.log(response);
      },
    });
    if(loggedInuserRole.role =='Admin')
    {
      this.modelService.getAllModel().subscribe({
        next: (models) => {
          this.models = models;
          console.log(this.models);
        },
      });
    }

    else
    {
      this.modelService.getAllModelForNonAdminUser().subscribe({
        next: (models) => {
          this.models = models;
          console.log(this.models);
        },
      });
    }
    // get plantId from breadcrumbs
    this.plantService.selectedPlant$
      .subscribe(plantId => {
        if (plantId) {
          this.getSelectedPlantId({ target: { value: plantId.toString() } });
        }
      });
  }

  nameChange() {
    this.nameValidator = false;
  }
  //stage 1
  Stage1ElementsVesselChange(){
    this.Stage1elementVesselsValidator = false;
  }
  Stage1Q1Change() {
    this.s1Q1Validator = false;
  }
  Stage1Q2Change() {
    this.s1Q2Validator = false;
  }
  Stage1VesselsChange() {
    this.stage1VesselValidatorH = false;
  }
  Stage1VesselsHChange() {
    this.stage1VesselValidator = false;
  }
  Stage2VesselsChange() {
    this.stage2VesselValidator = false;
  }
  Stage2Q1Change() {
    this.s2Q1Validator = false;
  }
  Stage2Q2Change() {
    this.s2Q2Validator = false;
  }
  Stage3VesselsChange() {
    this.stage3VesselValidator = false;
  }
  Stage3Q1Change() {
    this.s3Q1Validator = false;
  }
  Stage3Q2Change() {
    this.s3Q2Validator = false;
  }

  selecteduser(event) {
    console.log(this.selectedValues);
  }
  getFilteredUsers(comanyUsers: User[], selectedValues: User[]): User[]
  {
    return comanyUsers.filter(
      (user) =>
        !selectedValues.some((selectedValues) => selectedValues.Id === user.Id)

    );
    selectedValues.push(this.CurrentUserId);
  }
  validate() {
    if (this.addTrainRequest.PlantId == 0) {
      return false;
    } else if (this.addTrainRequest.Name == '') {
      return false;
    } else if ((this.addTrainUsers.AspNetUsersId = '')) {
      return false;
    } else if (this.addTrainRequest.Stages == 0) {
      return false;
    } else if (this.addTrainRequest.Stages == 1) {
      if (this.addTrainRequest.Hybrid == 0) {
        if (this.addTrainRequest.Stage1Element1Model == 0) {
          return false;
        } else if (this.addTrainRequest.Stage1ElementsVessel == 0) {
          return false;
        } else if (this.addTrainRequest.Stage1ElementsVessel == 0) {
          return false;
        }
      } else {
        if (this.addTrainRequest.Stage1Element1Model == 0) {
          return false;
        } else if (this.addTrainRequest.Stage1Element2Model == 0) {
          return false;
        }
      }
    } else if (this.addTrainRequest.Stages == 2) {
      //stage 2
      if (this.addTrainRequest.Hybrid2 == 0) {
        //stage 2 NH
        if (this.addTrainRequest.Stage2ElementModel == 0) {
          return false;
        } else if (this.addTrainRequest.Stage2ElementsVessel == 0) {
          return false;
        } else if (this.addTrainRequest.Stage2Vessels == 0) {
          return false;
        }
      } else {
        if (this.addTrainRequest.Stage2ElementModel == 0) {
          return false;
        } else if (this.addTrainRequest.Stage1Element1Qty == 0) {
          return false;
        } else if (this.addTrainRequest.Stage2Element2Model == 0) {
          return false;
        } else if (this.addTrainRequest.Stage2Element2Qty == 0) {
          return false;
        } else if (this.addTrainRequest.Stage2Vessels == 0) {
          return false;
        }
      }
    } else if (this.addTrainRequest.Stages == 3) {
      if (this.addTrainRequest.Hybrid3 == 0) {
        //stage 3 NH
        if (this.addTrainRequest.Stage3ElementModel == 0) {
          return false;
        } else if (this.addTrainRequest.Stage3ElementsVessel == 0) {
          return false;
        } else if (this.addTrainRequest.Stage3Vessels == 0) {
          return false;
        }
      } //stage 3 H
      else {
        if (this.addTrainRequest.Stage3ElementModel == 0) {
          return false;
        } else if (this.addTrainRequest.Stage3Element1Qty == 0) {
          return false;
        } else if (this.addTrainRequest.Stage3Element2Model == 0) {
          return false;
        } else if (this.addTrainRequest.Stage3Element2Qty == 0) {
          return false;
        } else if (this.addTrainRequest.Stage3ElementsVessel == 0) {
          return false;
        }
      }
    }
    return true;
  }
  addTrain() {
    console.log(this.addTrainRequest);
    this.addTrainRequest.PlantId=this.plantId;

    if (!this.plantId) {
      this.plantService.setPlantValidation(true);
      document.getElementById('plantDropdown')
        ?.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      return;
    }
    this.plantService.setPlantValidation(false);

    // if (this.addTrainRequest.PlantId == 0 || this.addTrainRequest.PlantId == undefined) {
    //   this.plantValidator = true;
    // }
    if (this.addTrainRequest.Name == '') {
      this.nameValidator = true;
    }
    if (this.addTrainRequest.Stages == 0) {
      this.stagevalidator = true;
    }
    //stage 1 non hybrid required controls
    if (this.addTrainRequest.Stages == 1) {
      if (this.addTrainRequest.Hybrid == 0) {
        if (this.addTrainRequest.Stage1Element1Model == 0) {
          this.stage1eleement1validator = true;
        }
        if (this.addTrainRequest.Stage1ElementsVessel == 0) {
          this.Stage1elementVesselsValidator = true;
        }
        if (this.addTrainRequest.Stage1Vessels == 0) {
          this.stage1VesselValidator = true;
        }
      } else {
        if (this.addTrainRequest.Stage1Element1Model == 0) {
          this.stage1element1hybridvalidator = true;
        }
        if (this.addTrainRequest.Stage1Element1Qty == 0) {
          this.s1Q1Validator = true;
        }
        if (this.addTrainRequest.Stage1Element2Qty == 0) {
          this.s1Q2Validator = true;
        }
        if (this.addTrainRequest.Stage1Element2Model == 0) {
          this.stage1element2hybridvalidator = true;
        }

        if ((this.addTrainRequest.Stage1Vessels == 0)) {
          this.stage1VesselValidatorH = true;
        }
      }
    }

    //stage 2 required controls
    if (this.addTrainRequest.Stages == 2) {
      if (this.addTrainRequest.Hybrid == 0) {
        if (this.addTrainRequest.Stage1Element1Model == 0) {
          this.stage1eleement1validator = true;
        }
        if (this.addTrainRequest.Stage1ElementsVessel == 0) {
          this.Stage1elementVesselsValidator = true;
        }
        if (this.addTrainRequest.Stage1Vessels == 0) {
          this.stage1VesselValidator = true;
        }
      }
      if (this.addTrainRequest.Hybrid == 1) {
        if (this.addTrainRequest.Stage1Element1Model == 0) {
          this.stage1element1hybridvalidator = true;
        }
        if (this.addTrainRequest.Stage1Element1Qty == 0) {
          this.s1Q1Validator = true;
        }
        if (this.addTrainRequest.Stage1Element2Qty == 0) {
          this.s1Q2Validator = true;
        }
        if (this.addTrainRequest.Stage1Element2Model == 0) {
          this.stage1element2hybridvalidator = true;
        }
        if (this.addTrainRequest.Stage1Vessels == 0) {
          this.stage1VesselValidatorH = true;
        }
      }
      if (this.addTrainRequest.Hybrid2 == 0) {
        if (this.addTrainRequest.Stage2ElementModel == 0) {
          this.stage2Element1validator = true;
        }
        if (this.addTrainRequest.Stage2Vessels == 0) {
          this.stage2VesselValidator = true;
        }
        if (this.addTrainRequest.Stage2ElementsVessel == 0) {
          this.Stage2elementVesselsValidator = true;
        }
      }
      if (this.addTrainRequest.Hybrid2 == 1) {
        if (this.addTrainRequest.Stage2ElementModel == 0) {
          this.stage2Element1validatorH = true;
        }
        if (this.addTrainRequest.Stage2Element1Qty == 0) {
          this.s2Q1Validator = true;
        }
        if (this.addTrainRequest.Stage2Element2Model == 0) {
          this.stage2Element2validatorH = true;
        }
        if (this.addTrainRequest.Stage2Element2Qty == 0) {
          this.s2Q2Validator = true;
        }
        if (this.addTrainRequest.Stage2ElementsVessel == 0) {
          this.Stage2elementVesselsValidatorH = true;
        }
        if (this.addTrainRequest.Stage2Vessels == 0) {
          this.stage2VesselValidatorH = true;
        }
      }
    }
    //stage 3 required fields
    if (this.addTrainRequest.Stages == 3) {
      if (this.addTrainRequest.Hybrid == 0) {
        if (this.addTrainRequest.Stage1Element1Model == 0) {
          this.stage1eleement1validator = true;
        }
        if (this.addTrainRequest.Stage1ElementsVessel == 0) {
          this.Stage1elementVesselsValidator = true;
        }
        if (this.addTrainRequest.Stage1Vessels == 0) {
          this.stage1VesselValidator = true;
        }
      }
      if (this.addTrainRequest.Hybrid == 1) {
        if (this.addTrainRequest.Stage1Element1Model == 0) {
          this.stage1element1hybridvalidator = true;
        }
        if (this.addTrainRequest.Stage1Element1Qty == 0) {
          this.s1Q1Validator = true;
        }
        if (this.addTrainRequest.Stage1Element2Qty == 0) {
          this.s1Q2Validator = true;
        }
        if (this.addTrainRequest.Stage1Element2Model == 0) {
          this.stage1element2hybridvalidator = true;
        }
        if (this.addTrainRequest.Stage1Vessels == 0) {
          this.stage1VesselValidatorH = true;
        }
      }
      if (this.addTrainRequest.Hybrid2 == 0) {
        if (this.addTrainRequest.Stage2ElementModel == 0) {
          this.stage2Element1validator = true;
        }
        if (this.addTrainRequest.Stage2Vessels == 0) {
          this.stage2VesselValidator = true;
        }
        if (this.addTrainRequest.Stage2ElementsVessel == 0) {
          this.Stage2elementVesselsValidator = true;
        }
      }
      if (this.addTrainRequest.Hybrid2 == 1) {
        if (this.addTrainRequest.Stage2ElementModel == 0) {
          this.stage2Element1validatorH = true;
        }
        if (this.addTrainRequest.Stage2Element1Qty == 0) {
          this.s2Q1Validator = true;
        }
        if (this.addTrainRequest.Stage2Element2Model == 0) {
          this.stage2Element2validatorH = true;
        }
        if (this.addTrainRequest.Stage2Element2Qty == 0) {
          this.s2Q2Validator = true;
        }
        if (this.addTrainRequest.Stage2ElementsVessel == 0) {
          this.Stage2elementVesselsValidatorH = true;
        }
        if (this.addTrainRequest.Stage2Vessels == 0) {
          this.stage2VesselValidatorH = true;
        }
      }

      if (this.addTrainRequest.Hybrid3 == 0) {
        if (this.addTrainRequest.Stage3ElementModel == 0) {
          this.stage3Element1validatorNH = true;
        }
        if (this.addTrainRequest.Stage3Vessels == 0) {
          this.stage3VesselValidator = true;
        }
        if (this.addTrainRequest.Stage3ElementsVessel == 0) {
          this.Stage3elementVesselsValidator = true;
        }
      }
      if (this.addTrainRequest.Hybrid3 == 1) {
        if (this.addTrainRequest.Stage3ElementModel == 0) {
          this.stage3Element1ValidatorH = true;
        }
        if (this.addTrainRequest.Stage3Element1Qty == 0) {
          this.s3Q1ValidatorH = true;
        }
        if (this.addTrainRequest.Stage3Element2Model == 0) {
          this.stage3Element2Validator = true;
        }
        if (this.addTrainRequest.Stage3Element2Qty == 0) {
          this.s3Q2Validator = true;
        }
        if (this.addTrainRequest.Stage3Vessels == 0) {
          this.stage3VesselValidatorH = true;
        }
      }
    }
    if (this.validate()) {
      this.userLister = this.getFilteredUsers(
        this.comanyUsers,
        this.selectedValues
      );
      console.log(this.userLister);

      const dateNowISO = this.dateNow.toISOString();

      this.addTrainRequest.CreatedAt = new Date(dateNowISO);
      this.addTrainRequest.UpdatedAt = new Date(dateNowISO);
      this.addTrainRequest.UserId = 0;
      this.addTrainRequest.AspNetUsersId = this.CurrentUserId;

      let trainobj = new TrainViewmodel();
      trainobj.traindata = this.addTrainRequest;

      if (this.addTrainRequest.AccessOption == 1) {
        this.selectedValues.forEach((element) => {
          this.addTrainUsers = new TrainUsers();
          this.addTrainUsers.TrainId = this.addTrainRequest.Id;
          this.addTrainUsers.AspNetUsersId = element.Id;
          this.addTrainUsers.UserId = +element.UserId;
          this.addTrainUsers.IsAdmin = 0;
          this.addTrainUsers.AccessFlag = false;

          this.addTrainUsers.CreatedAt = new Date(dateNowISO);
          this.addTrainUsers.UpdatedAt = new Date(dateNowISO);
          trainobj.trainuser.push(this.addTrainUsers);
        });
        this.userLister.forEach((element) => {
          this.addTrainUsers = new TrainUsers();
          this.addTrainUsers.TrainId = this.addTrainRequest.Id;
          this.addTrainUsers.AspNetUsersId = element.Id;
          this.addTrainUsers.UserId = +element.UserId;
          this.addTrainUsers.IsAdmin = 0;

          this.addTrainUsers.AccessFlag = true;
          this.addTrainUsers.CreatedAt = new Date(dateNowISO);
          this.addTrainUsers.UpdatedAt = new Date(dateNowISO);
          trainobj.trainuser.push(this.addTrainUsers);
        });
      } else if (this.addTrainRequest.AccessOption == 0) {
        this.selectedValues.forEach((element) => {
          this.addTrainUsers = new TrainUsers();
          this.addTrainUsers.TrainId = this.addTrainRequest.Id;
          this.addTrainUsers.AspNetUsersId = element.Id;
          this.addTrainUsers.UserId = +element.UserId;
          this.addTrainUsers.IsAdmin = 0;
          this.addTrainUsers.AccessFlag = true;
          this.addTrainUsers.CreatedAt = new Date(dateNowISO);
          this.addTrainUsers.UpdatedAt = new Date(dateNowISO);
          trainobj.trainuser.push(this.addTrainUsers);
        });
        this.userLister.forEach((element) => {
          this.addTrainUsers = new TrainUsers();
          this.addTrainUsers.TrainId = this.addTrainRequest.Id;
          this.addTrainUsers.AspNetUsersId = element.Id;
          this.addTrainUsers.UserId = +element.UserId;
          this.addTrainUsers.IsAdmin = 1;
          //Below code added by smita on 7th May 2025 to give explicit access to train creator when 
          //it is not selected in list
          if(this.CurrentUserId == element.Id)
          {
            this.addTrainUsers.AccessFlag = true;
          }
          else
          {
            //below was original
            this.addTrainUsers.AccessFlag = false;
          }
          this.addTrainUsers.CreatedAt = new Date(dateNowISO);
          this.addTrainUsers.UpdatedAt = new Date(dateNowISO);
          trainobj.trainuser.push(this.addTrainUsers);
        });
      }
      console.log(trainobj);
      this.trainService.addTrain(trainobj).subscribe({
        next: (Train) => {
          if (Train.Id > 0) {
            console.log(trainobj);
            var id = btoa(Train.Id.toString())
            this.toastr.success('Train created successfully.', 'Information');
            this.plantService.setSelectedTrain(Train.Id);
            this.router.navigate(['/component/trains/edit/' + id]);
          }
        },
        error: (response) => {
          if (response.error.length > 0) {
            this.toastr.error(response.error, 'Error');
          } else {
            this.toastr.error('Error While Creating Train.', 'Error');
          }
        },
      });
    }
  }

onCancel(): void {
  if (this.plantId) {
    this.plantService.setSelectedPlant(this.plantId);
  }

  this.router.navigate(['/trains']);
}
}
